import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { UserManagement } from "./UserManagement";
import UserManagementQueryNode from "./__generated__/UserManagementQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof UserManagement> = {
  root: JSResource("UserManagement", () =>
    import("./UserManagement").then((module) => module.UserManagement),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: UserManagementQueryNode,
          variables: {},
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
